import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { UsersA3LModel } from '../models/UserA3L.model';
import { UserA3LRelations } from '../models/userA3LRelations';
import { SetPasswordModel } from '../models/setPassword.model';

@Injectable()
export class UserService extends HttpClientBaseService implements IServiceBase<User> {

  constructor(_http: HttpClient) {
    super(_http,'account/users/','',false);

  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<User>> {
    throw new Error('Method not implemented.');
  }
  getAllModels(): Observable<User[]> {
    return super.getAll<User[]>();
  }
  getModel(id: any): Observable<User> {
    return super.getSingle<User>(id);
  }

  public getUser(userName: string): Observable<User> {
    const url = `${this.getConcatUrl()}GetByUserName/${userName}`;
    return super.get<User>(url);
  }

  public setPassword(setPassword: SetPasswordModel): Observable<Object> {
    const url = `${this.getConcatUrl()}setPassword/`;
    return this.http.post(url, setPassword, {responseType:'text'});
  }

  public isAdmin(userName: string): Observable<boolean> {
    const url = `${super.getBaseUrl}/isAdmin/${userName}`;
    return super.get<boolean>(url);
  }

  public generateA3LUsers(users: UsersA3LModel){
    const url = `${this.getConcatUrl()}A3LEmployeesRegister/`;
    return this.http.post(url,users);
  }

  public selectCompany(userA3lRelations: UserA3LRelations){
    const url = `${this.getConcatUrl()}SelectCompany/`;
    return this.http.post(url, userA3lRelations);
  }
}
